// src/pages/club/settings/api/ClubProviderAPI.js
import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ClubSubscriptionAPI {
    URI_V1 = "/v1/club/subscriptions";

    getCompanyId() {
        const cm = companyAPI.getCompanyManagment();
        return cm?.id;
    }

    bulkCreate(clubPlanId: any, customerIds: any) {
        const payload = {
            clubPlanId,
                customerIds,
        }
        return apiService.post(
            `${this.URI_V1}/bulk?companyId=${this.getCompanyId()}`, payload);
    }


    getCustomersByClub(clubPlanId: any) {
        return apiService.get(`${this.URI_V1}/${clubPlanId}/customers?companyId=${this.getCompanyId()}`);
    }

    getCustomerSubscriptions(customerId: any) {
        return apiService.get(`${this.URI_V1}/customer/${customerId}?companyId=${this.getCompanyId()}`);
    }

    
    generateLink(subscriptionId: any) {
        return apiService.post(`${this.URI_V1}/${subscriptionId}/generate-link?companyId=${this.getCompanyId()}`, null);
    }

    cancel(subscriptionId: any) {
        return apiService.post(
            `${this.URI_V1}/${subscriptionId}/cancel?companyId=${this.getCompanyId()}`, null);
    }

}
